module.exports = __webpack_public_path__ + "img/home-hero-desktop-img-01.3950fbc2.svg";